var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCheckbox',{staticClass:"flex flex-row space-x-4 items-center",class:{
    'text-gray-700': !_vm.value,
    'text-gray-900': _vm.value,
    'opacity-50 cursor-not-allowed': _vm.disabled,
  },attrs:{"id":_vm.id,"value":_vm.value,"disabled":_vm.disabled},on:{"input":_vm.onInput}},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }